import * as React from "react"
import { useEffect, useRef }  from "react";
import { useSignal } from "@preact/signals-react";
import { Box } from "@mui/material";
import { ButtonLoadingSeeker, ButtonSeeker } from "@ui-seeker/core";

import { useToast } from "@hooks";
import { commonFiltersValue, disabledCommonFiltersSubmit, isLoadingCommonFilters, resetCommonFilters, triggerCommonFiltersSubmit } from "@signals";

const __defaultSubmit = async data => console.log(data)

export default function CommonFiltersFooterActions({ onSubmit=null, components={}, launch=false, downloadCSV=null }) {

    const { showToast } = useToast()
    const isDownloadingExcel = useSignal(false)
    const triggerValue = triggerCommonFiltersSubmit.value
    const prevTriggerRef = useRef(triggerValue)

    const handleClick = async () => {
        isLoadingCommonFilters.value = true
        const fn = onSubmit || __defaultSubmit
        const filters = {
            ...commonFiltersValue.value,
            ...components.currentPrevDates && {
                startDate: commonFiltersValue.value.currentSingleDate,
                endDate: commonFiltersValue.value.currentSingleDate,
                prevStartDate: commonFiltersValue.value.prevSingleDate,
                prevEndDate: commonFiltersValue.value.prevSingleDate
            }
        }
        try {
            fn(filters).finally(() =>
                isLoadingCommonFilters.value = false
            )
        } catch (e) {}
    }

    useEffect(() => {
        if (launch && !disabledCommonFiltersSubmit.value){
            handleClick()
        }
    },[])

    // Monitorear trigger del tour — solo disparar cuando CAMBIA, no al montar
    useEffect(() => {
        if (triggerValue !== prevTriggerRef.current) {
            prevTriggerRef.current = triggerValue
            handleClick()
        }
    }, [triggerValue])

    return <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!!downloadCSV && <ButtonLoadingSeeker
            disabled={isDownloadingExcel.value}
            loading={isDownloadingExcel.value}
            sx={{ mr: 2, backgroundColor: 'success.lighter' }}
            onClick={async () => {
                isDownloadingExcel.value = true
                try {
                    await showToast.promiseExcel(
                        downloadCSV,
                        { limitResults: false },
                        null,
                        { pending: 'Downloading CSV (This may take a few minutes).' }
                    )
                } finally {
                    isDownloadingExcel.value = false
                }
            }}
        >
            Download CSV
        </ButtonLoadingSeeker>}
        <ButtonSeeker variant="outlined" sx={{ mr: 2 }} onClick={resetCommonFilters}>
            Reset Search
        </ButtonSeeker>
        <ButtonLoadingSeeker disabled={disabledCommonFiltersSubmit.value} onClick={handleClick} loading={isLoadingCommonFilters.value}>
            Search
        </ButtonLoadingSeeker>
    </Box>
}
